<template>
  <div class="search-condition">
    <h3>搜索条件</h3>
    <el-form :model="form" ref="form" label-width="100px" class="form-container bordered-form">
      <el-row :gutter="40">
        <!-- 增加列间距 -->
        <el-col :span="8">
          <!-- 增加列宽度 -->
          <el-form-item label="日期:">
            <el-date-picker
              v-model="form.date"
              type="month"
              placeholder="选择月份"
              value-format="yyyy-MM"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 增加列宽度 -->
          <el-form-item label="工单类型:">
            <el-select clearable  v-model="form.ticketType" placeholder="请选择">
              <el-option
                v-for="item in ticketTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <!-- 增加列宽度 -->
          <el-form-item label="是否超时">
            <el-select clearable  v-model="form.isDelay" placeholder="请选择">
              <el-option
                v-for="item in isDelay"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">

          <!-- 增加列宽度 -->
          <el-form-item label="SLA:">
            <el-date-picker
              v-model="form.expectDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="margin-top: 20px;">
          <el-button @click="handleQuery" class="query-btn">点击查询</el-button>
          <el-button @click="clearForm" class="clear-btn">一键清空</el-button>
          <el-button
            @click="exportData"
            :class="{ 'export-btn': true, 'export-selected-btn': selectedRows.length > 0 }"
          >
            {{ exportButtonText }}
          </el-button>
          <el-button @click="openColumnsDialog" class="columns-btn" style="float: right;"
            >设置显示项</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <h3 class="table-title">工单列表</h3>
    <!-- 添加标题 -->
    <el-table
      :data="tableData"
      ref="table"
      style="width: 100%; margin-top: 20px;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        v-for="(column, index) in visibleColumns"
        :key="index"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
      ></el-table-column>
    </el-table>
    <el-dialog title="设置显示项" :visible.sync="showColumnsDialog">
      <el-checkbox-group v-model="selectedColumns" style="margin-top: 10px;">
        <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop">{{
          column.label
        }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectAllColumns">全选</el-button>
        <el-button @click="restoreDefaultColumns">恢复默认</el-button>
        <el-button type="primary" @click="saveColumnsDialog">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'; // 引入 moment.js 来处理日期
import XLSX from 'xlsx';

export default {
  data() {
    return {
      form: {
        expectDate: moment().format('YYYY-MM-DD'), // 默认设置为当前年月日
        date: moment().format('YYYY-MM'), // 默认设置为当前月份
        ticketType: '服务器搬迁', // 默认设置为维修单
      },
      ticketTypes: [
        { value: '网络工单', label: '网络工单' },
        { value: 'tcp异常', label: 'tcp异常' },
        { value: '服务器搬迁', label: '服务器搬迁' },
        { value: '服务器退役', label: '服务器退役' },
        { value: '服务器故障', label: '服务器故障' },
        { value: '机框出库', label: '机框出库' },
      ],
      isDelay: [
        { value: '是', label: '是' },
        { value: '否', label: '否' },
      ],
      tableData: [],
      showColumnsDialog: false,
      selectedColumns: [
        'index',
        'TicketId',
        'title',
        'handler',
        'state',
        'ticketType',
        'InspectionResult',
        'bizAreaName',
        'counts',
      ],
      defaultSelectedColumns: [
        'index',
        'TicketId',
        'title',
        'handler',
        'state',
        'ticketType',
        'InspectionResult',
        'bizAreaName',
        'counts',
      ],
      columns: [
        { prop: 'index', label: '序号', width: 80 },
        { prop: 'TicketId', label: '工单ID', width: 180 },
        { prop: 'title', label: '工单标题', width: 240 },
        { prop: 'handler', label: '处理人', width: 180 },
        { prop: 'createTime', label: '创建时间', width: 180 },
        { prop: 'state', label: '状态', width: 120 },
        { prop: 'ticketType', label: '工单类型', width: 120 },
        { prop: 'InspectionResult', label: '巡检结果', width: 180 },
        { prop: 'SchemeType', label: '场景类型', width: 120 },
        { prop: 'assigner', label: '派单人', width: 180 },
        { prop: 'auditId', label: '审计单号', width: 180 },
        { prop: 'bizAreaName', label: '一级机房', width: 180 },
        { prop: 'completeTime', label: '结单时间', width: 180 },
        { prop: 'completer', label: '结单人', width: 180 },
        { prop: 'counts', label: '工单涉及设备数量', width: 180 },
        { prop: 'expectFinishTime', label: '期望结单时间', width: 180 },
        { prop: 'expectOperateTime', label: '期望操作时间', width: 180 },
        { prop: 'id', label: 'ID', width: 180 },
        { prop: 'inspectionId', label: '巡检单号', width: 180 },
        { prop: 'instanceId', label: '催办单单号', width: 180 },
        { prop: 'isAudit', label: '驻场回复', width: 120 },
        { prop: 'isDelay', label: '是否超时', width: 120 },
        { prop: 'isInspection', label: '是否巡检派单', width: 140 },
        { prop: 'isPause', label: '工单是否挂起', width: 140 },
        { prop: 'isRecheck', label: '复检是否正常', width: 140 },
        { prop: 'isResource', label: '是否资源申请', width: 140 },
        { prop: 'isRush', label: '是否催办', width: 120 },
        { prop: 'pauseCheckDelayTime', label: '工单挂起时间', width: 180 },
        { prop: 'pausePic', label: '工单挂起图片', width: 180 },
        { prop: 'resourceId', label: '资源申请单号', width: 180 },
        { prop: 'rushMessage', label: '催办回复', width: 180 },
        { prop: 'supplyName', label: '服务商', width: 120 },
        { prop: 'ticketNo', label: '上游单号', width: 180 },
      ],
      visibleColumns: [],
      selectAll: false,
      isIndeterminate: false,
      selectedRows: [],
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? '导出选中' : '导出全部';
    },
  },
  methods: {
    handleQuery() {
      const payload = {
        Date: this.form.date,
        TicketType: this.form.ticketType,
        VueOperateUser: '',
      };
      axios
        .post('/api/v1/ops/get_network_list', payload)
        .then((response) => {
          this.tableData = response.data.data.Data;
        })
        .catch((error) => {
          console.error('There was an error fetching the data!', error);
        });
    },
    clearForm() {
      this.$refs.form.resetFields();
      this.tableData = [];
    },
    exportData() {
      let dataToExport;
      if (this.selectedRows.length > 0) {
        dataToExport = this.selectedRows;
      } else {
        dataToExport = this.tableData;
      }

      if (dataToExport.length === 0) {
        this.$message.warning('没有数据可导出');
        return;
      }

      const worksheetData = dataToExport.map((row) => {
        const rowData = {};
        this.visibleColumns.forEach((column) => {
          rowData[column.label] = row[column.prop];
        });
        return rowData;
      });

      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, '工单数据.xlsx');
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.search-condition {
  padding: 20px;
}

.form-container {
  max-width: 1200px;
  margin: 0 auto;
}

.bordered-form {
  border: 1px solid #dcdfe6; /* 添加边框 */
  padding: 20px; /* 内边距，使内容与边框之间有间隔 */
  border-radius: 4px; /* 圆角边框，可选 */
}

.query-btn {
  margin-right: 10px;
}

.clear-btn {
  margin-right: 10px;
}

.export-btn {
  margin-right: 10px;
}

.columns-btn {
  margin-right: 10px;
  float: right;
}

/* 新增表格样式 */
.el-table {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.el-table th,
.el-table td {
  padding: 12px 0;
  text-align: center;
  border-bottom: 1px solid #ebeef5;
}

.el-table th {
  background-color: #f5f7fa;
}

.el-table tr:hover {
  background-color: #f5f7fa;
}

.el-table::before {
  height: 0;
}

/* 新增标题样式 */
.table-title {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
</style>
